import {
  DropDownList,
  FieldSettingsModel,
} from '@syncfusion/ej2-react-dropdowns';
import {DataManager, ODataV4Adaptor, WebApiAdaptor} from '@syncfusion/ej2-data';
import { store } from '../store';
import { datasource } from '../layout/test/data';
import Cookies from "js-cookie";

const GetBackendUrlForGlobalFunctions = () => {
  const state = store.getState(); // Redux store'dan state'i çekiyoruz
  const backEndUrl = state.search.backEndUrl;
  return backEndUrl;
};

export const getParamsDD = (
  fields: FieldSettingsModel,
  value: string | undefined,
  api: string,
  isReturnValu?: boolean,
  islabel?: boolean
) => {
  let theElement: any;
  let theObj: any;
  let baseURL =GetBackendUrlForGlobalFunctions();
  let url =baseURL + api;
  const token = Cookies.get('token');
  let dataSource: DataManager = new DataManager({
    adaptor: new WebApiAdaptor(),
    crossDomain: true,
    url: url,
    headers: [{
      Authorization: `Bearer ${token}`,
      contentType: 'application/json',
    }],
  });

  const theEditParams = {
    create: () => {
      theElement = document.createElement('input');
      return theElement;
    },
    destroy: () => {
      theObj && theObj.destroy();
    },
    read: () => {
      return isReturnValu ? theObj.value : theObj.text;
    },
    write: (args: any) => {
      theObj = new DropDownList({
        change: () => {},
        dataSource: dataSource,
        fields: fields,
        floatLabelType: 'Never',
        allowFiltering: true,
        text: args.rowData[`${value}`]?.trim(),
        value: islabel
          ? args.rowData[`label`]?.trim()
          : args.rowData[`${value}`]?.trim(),
      });
      theObj.appendTo(theElement);
    },
  };
  return theEditParams;
};
